"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditCheckSchema = void 0;
exports.creditCheckSchema = {
    type: ['object', 'null'],
    required: [
        'cmhcAccountNumber',
        'typeID',
        'bankruptcyIndicator',
        'creditAgencyBorrowerID',
        'creditAgencyID',
        'creditCheckResultTypeCode',
        'creditScoreReasonTypeCode1',
        'creditScoreReasonTypeCode2',
        'creditScoreReasonTypeCode3',
        'creditScoreReasonTypeCode4',
        'genericCreditScoreCount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'rejectReasonTypeCode',
        'thinFileIndicator',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be an integer between 0 and 999999999999',
        },
        typeID: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        cmhcApplicantID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        bankruptcyIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        creditAgencyBorrowerID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        creditAgencyCurrentInquiriesCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        creditAgencyID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditAgencyTotalInquiriesCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        creditCheckResultTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode1: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode2: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode3: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode4: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        genericCreditScoreCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        helocTradesCreditLimitAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance or null',
        },
        helocTradesOutstandingBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance or null',
        },
        lastUnfavourableCreditRatingPeriod: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters or null',
        },
        mortgageOrHelocTradeWorstLastTwelveMonthCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        mortgageOrHelocWorstRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        mortgageTradesOutstandingBalanceLastTwelveMonthAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance or null',
        },
        publicRecordDelinquentCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        rejectReasonTypeCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        revolvingDebtBurdenAmount: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: -999,
            decimal: [7, 4],
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        thinFileIndicator: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        totalMonthlyPaymentPastDueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and fixed 2 digits of significance or null',
        },
        worstCurrentCreditRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        worstEverCreditRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
    },
};
exports.default = exports.creditCheckSchema;
